import { GRAPHQL_AUTH_MODE } from "@aws-amplify/api-graphql";
import { Auth } from "aws-amplify";

/** Return the correct Auth mode based on if there is an authenticated user. */
export const getAuthMode = async () => {
  const response = await Auth.currentUserInfo();
  if (!response) return GRAPHQL_AUTH_MODE.AWS_IAM;
  return GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS;
};
